import { useQuery } from '@tanstack/react-query'
import axiosClient from '../../axios'

export interface MyCollaborator {
  email: string
  jobTitle: string | null
  status: 'pending' | 'accepted'
  caseCount: number
  lastSharedAt: string
}

/**
 * Every collaborateur (role='editor') the current user has ever invited,
 * across ALL their cases, deduplicated by email. Backs the "/my-info"
 * profile page and the share modal's quick-pick (reuse an already-active
 * collaborator on a different case without retyping their email).
 */
export function useMyCollaborators(enabled = true) {
  return useQuery({
    queryKey: ['blot-analysis', 'my-collaborators'],
    enabled,
    queryFn: async () => {
      const { data } = await axiosClient.get<{ success: boolean; collaborators: MyCollaborator[] }>(
        '/blot-analysis/my-collaborators',
      )
      return data.collaborators
    },
    staleTime: 30_000,
  })
}
